/**
 * Transformer that prefills all necessary fields about user's address
 * if they click on 'Prefill address' checkbox on `personal-info` page.
 * The address is the same as the one that was specified at the start of the flow.
 */
export default (kasko) => {
  kasko.addEventListener('form-changed', ({ current, previous }) => {
    const state = kasko.getState();

    if (!state.route.state.url.includes('personal-info')) {
      return;
    }

    if (current.is_prefill_address === previous.is_prefill_address) {
      return;
    }

    if (current.is_prefill_address) {
      kasko.dispatchEvent('set-form-input', {
        postcode: state.input.risk_address_postcode,
        postcode_city: state.input.risk_address_postcode_city,
        postcode_city_human: state.input.risk_address_postcode_city_human,
        street: state.input.risk_address_street,
        city: state.input.risk_address_city,
        house_number: state.input.risk_address_house_number,
      });
    } else {
      kasko.dispatchEvent('set-form-input', {
        postcode: '',
        street: '',
        city: '',
        house_number: '',
        postcode_city: '',
        postcode_city_human: '',
      });
    }
  });
};
